<template>
  <!-- フッター -->
  <div class="footer-wrapper">
    <div class="footer double-scroll-padding">
      <el-row>
        <el-col :span="12" class="actions">
          <router-link :to="returnTo" class="return">
            <jr-button type="info" size="small" class="return-btn">戻る</jr-button>
          </router-link>
        </el-col>
        <el-col :span="12" class="actions align-right">
          <router-link
            :to="{ name: 'BoundaryEdit', params: { request_header_id: requestHeaderId } }"
            v-if="isEditBtnVisible"
          >
            <jr-button type="primary" size="small" class="edit-btn">変更</jr-button>
          </router-link>
          <router-link
            :to="{
              name: 'NormalMessageSend',
              params: {
                message_type: MessageTypes.B_APPLICANT_CALL,
                action: 'send',
                request_header_id: form.request_header_id,
              },
            }"
            v-if="isApplicantContactBtnVisible"
          >
            <jr-button-for-jr size="small" class="contact-btn">協議先連絡</jr-button-for-jr>
          </router-link>
          <jr-button v-if="isEdit" type="primary" size="small" class="save-confirm-btn" @click="save">保存</jr-button>
        </el-col>
      </el-row>
    </div>
  </div>

  <el-form :model="form" :rules="rules" ref="formRef" class="double-scroll-padding" v-if="form != null">
    <!-- 申請基本 -->
    <input-group>
      <el-row class="input-row" v-if="mode !== 'add'">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label> 申請番号 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="applicant_number" class="applicant_number" size="small">
            <jr-text shadow="never" v-model="form.applicant_number" :isEdit="false" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row" v-if="mode !== 'add'">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label> 申請日時 </input-label>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="applicant_time" class="applicant_time" size="small">
            <jr-date-time-picker size="small" v-model="form.applicant_time" :isEdit="false" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label :required="isEdit"> 担当保守区</input-label>
        </el-col>
        <el-col :span="12">
          <el-form-item prop="department" class="department" size="small">
            <Suspense>
              <department-select
                v-model="form.department"
                @update:code="form.department_code = $event"
                @update:name="form.department_name = $event"
                size="small"
                :isEdit="isEdit"
                :isLand="true"
              />
            </Suspense>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label :required="isEdit">標題</input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_title" class="applicant_title" size="small">
            <jr-text :isEdit="isEdit" v-model="form.applicant_title" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col class="text-xs align-middle error-message-padding-small" :span="5">
          <input-label>キロ程</input-label>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="meter" class="meter" size="small">
            <input-kilo size="small" v-model="form.meter" :isEdit="isEdit" />
          </el-form-item>
        </el-col>
        <el-col class="text-xs align-middle error-message-padding-small" :span="2" :offset="1">
          <input-label>左右</input-label>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="direction" class="direction" size="small">
            <direction-select size="small" v-model="form.direction" :isEdit="isEdit" :nullable="true" :blank="true" />
          </el-form-item>
        </el-col>
      </el-row>
    </input-group>

    <collapse-group title="申請者" class="my" :isOpen="isEdit">
      <!-- 事業者名(法人の場合) -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 法人名(法人の場合) </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_business_name" class="applicant_business_name" size="small">
            <jr-text v-model="form.applicant_business_name" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 担当者氏名 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 氏名 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_manager_name" class="applicant_manager_name" size="small">
            <jr-text v-model="form.applicant_manager_name" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 住所 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 住所 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_address" class="applicant_address" size="small">
            <jr-text v-model="form.applicant_address" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 申請者電話番号 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 電話番号 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_tel" class="applicant_tel" size="small">
            <jr-text v-model="form.applicant_tel" :isEdit="isEdit" placeholder="000-000-0000" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>

    <collapse-group title="代理人" class="my" :isOpen="isEdit">
      <!-- 事業者名(法人の場合) -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 法人名(法人の場合) </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="boundary.agent_corporate_name" class="agent_corporate_name" size="small">
            <jr-text v-model="form.boundary.agent_corporate_name" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 担当者氏名 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 氏名 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="boundary.agent_name" class="agent_name" size="small">
            <jr-text v-model="form.boundary.agent_name" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 住所 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 住所 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="boundary.agent_address" class="agent_address" size="small">
            <jr-text v-model="form.boundary.agent_address" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>

    <collapse-group title="連絡先（立会に来られる方）" class="my" :isOpen="isEdit">
      <!-- 連絡先電話番号 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 電話番号 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="boundary.contact_tel" class="contact_tel" size="small">
            <jr-text v-model="form.boundary.contact_tel" :isEdit="isEdit" placeholder="000-000-0000" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- メールアドレス -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label> メールアドレス </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="applicant_email" class="applicant_email" size="small">
            <jr-text v-model="form.applicant_email" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>

    <collapse-group title="申請内容" class="my" :isOpen="isEdit">
      <!-- 申請目的 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 申請目的 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="boundary.request_reason_type" class="request_reason_type" size="small">
            <request-reason-type-select :isEdit="isEdit" v-model="form.boundary.request_reason_type" size="small" />
          </el-form-item>
        </el-col>
        <el-col :span="6" :offset="1" class="text-xs align-middle error-message-padding-small">
          <input-label> (その他の場合記入) </input-label>
        </el-col>
        <el-col :span="6">
          <form-item-disabled
            prop="boundary.request_reason_type_other"
            class="request_reason_type_other"
            size="small"
            :disabled="form.boundary.request_reason_type !== RequestReasonTypes.OTHER.code"
          >
            <jr-text
              v-model="form.boundary.request_reason_type_other"
              :isEdit="isEdit"
              :disabled="form.boundary.request_reason_type !== RequestReasonTypes.OTHER.code"
              size="small"
            />
          </form-item-disabled>
        </el-col>
      </el-row>
      <!-- 作業内容 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label> 作業内容 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="boundary.work_content_count" class="work_content_count" size="small">
            <jr-checkbox
              :isEdit="isEdit"
              v-if="isEdit || form.boundary.is_boundary_marker_confirm"
              v-model="form.boundary.is_boundary_marker_confirm"
              class="is_boundary_marker_confirm w-100"
              size="small"
            >
              境界標確認
            </jr-checkbox>
            <jr-checkbox
              :isEdit="isEdit"
              v-if="isEdit || form.boundary.is_boundary_marker_restore"
              v-model="form.boundary.is_boundary_marker_restore"
              class="is_boundary_marker_restore w-100"
              size="small"
            >
              境界標復元
            </jr-checkbox>
            <jr-checkbox
              :isEdit="isEdit"
              v-if="isEdit || form.boundary.is_boundary_fixed_surveying"
              v-model="form.boundary.is_boundary_fixed_surveying"
              class="is_boundary_fixed_surveying w-100"
              size="small"
            >
              境界確定測量
            </jr-checkbox>
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>

    <collapse-group title="申請地" class="my" :isOpen="isEdit">
      <!-- 所在 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 所在 </input-label>
        </el-col>
        <el-col :span="13">
          <el-form-item prop="boundary.location" class="location" size="small">
            <jr-text v-model="form.boundary.location" :isEdit="isEdit" />
          </el-form-item>
        </el-col>
        <el-col :span="6" class="align-middle error-message-padding-small" style="padding-left: 4px">
          <jr-geocoder
            v-if="isEdit"
            :address="form.boundary.location"
            v-model:lat="mapCenterLat"
            v-model:lng="mapCenterLng"
            @change="changeMapCenter"
            size="small"
          >
            住所から地図を表示
          </jr-geocoder>
        </el-col>
      </el-row>
      <!-- 地番 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 地番 </input-label>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="boundary.parcel_number" class="parcel_number" size="small">
            <jr-text v-model="form.boundary.parcel_number" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
        <!-- 地目 -->
        <el-col :span="2" :offset="1" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 地目 </input-label>
        </el-col>
        <el-col :span="4">
          <el-form-item prop="boundary.land_category" class="land_category" size="small">
            <jr-text v-model="form.boundary.land_category" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
        <!-- 地積 -->
        <el-col :span="2" :offset="1" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 地積 </input-label>
        </el-col>
        <el-col :span="5">
          <el-form-item prop="boundary.parcel_area" class="parcel_area" size="small">
            <jr-number
              v-model="form.boundary.parcel_area"
              :isEdit="isEdit"
              :isString="true"
              :min="0"
              :step="0.01"
              size="small"
              :autoDecimalOfBlur="2"
            >
              <template #suffix>m<sup>2</sup></template>
            </jr-number>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 路線・駅間 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 路線 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="boundary.line" class="line" size="small">
            <Suspense>
              <line-select
                v-model="form.boundary.line"
                @update:name="form.boundary.line_name = $event"
                :isEdit="isEdit"
                :nullable="true"
                size="small"
              />
            </Suspense>
          </el-form-item>
        </el-col>
        <el-col :span="2" :offset="1" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 駅間 </input-label>
        </el-col>
        <el-col :span="4">
          <el-form-item
            prop="boundary.start_station"
            class="start_station"
            :error="validationError.start_station"
            size="small"
          >
            <Suspense>
              <station-select
                v-model="form.boundary.start_station"
                :lineCode="form.boundary.line"
                :isEdit="isEdit"
                :filterByLine="true"
                :nullable="true"
                @update:name="form.boundary.start_station_name = $event"
                size="small"
              />
            </Suspense>
          </el-form-item>
        </el-col>
        <el-col :span="1" class="text-xs align-middle error-message-padding-small">
          <span class="mx-2">～</span>
        </el-col>
        <el-col :span="4">
          <el-form-item
            prop="boundary.end_station"
            class="end_station"
            :error="validationError.end_station"
            size="small"
          >
            <Suspense>
              <station-select
                v-model="form.boundary.end_station"
                :lineCode="form.boundary.line"
                :isEdit="isEdit"
                :filterByLine="true"
                :nullable="true"
                @update:name="form.boundary.end_station_name = $event"
                size="small"
              />
            </Suspense>
          </el-form-item>
        </el-col>
      </el-row>
      <el-collapse v-if="!isEdit" @change="mapCollapseChange" class="map-collapse-no-load">
        <el-collapse-item title="申請地(地図)">
          <el-form-item prop="boundary.latitude" size="small" class="latitude">
            <jr-map
              :centerLat="mapCenterLat"
              :centerLng="mapCenterLng"
              v-model:lat="form.boundary.latitude"
              v-model:lng="form.boundary.longitude"
              :zoom="mapZoom"
              :load="mapLoad"
              :isEdit="false"
              style="width: 100%; height: 600px"
            />
          </el-form-item>
        </el-collapse-item>
      </el-collapse>

      <el-row v-if="isEdit">
        <el-col :span="12">
          <input-label :required="true"> 工事場所 </input-label>
          <span>(地図上でクリックしてください。)</span><br />
          <span class="text-xs pl-1">マウスホイール（またはピンチ）により拡大・縮小できます。</span>
        </el-col>
      </el-row>
      <el-row v-if="isEdit">
        <el-col :span="24">
          <el-form-item prop="boundary.latitude" size="small" class="latitude">
            <jr-map
              v-model:centerLat="mapCenterLat"
              v-model:centerLng="mapCenterLng"
              v-model:lat="form.boundary.latitude"
              v-model:lng="form.boundary.longitude"
              :zoom="mapZoom"
              :isEdit="true"
              style="width: 100%; height: 600px"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>
    <collapse-group title="JR用地情報" class="my" :isOpen="isEdit">
      <!-- 所在 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 所在 </input-label>
        </el-col>
        <el-col :span="19">
          <el-form-item prop="boundary.jr_site_location" class="jr_site_location" size="small">
            <jr-text v-model="form.boundary.jr_site_location" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 地番 -->
      <el-row class="input-row row-height">
        <el-col :span="5" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 地番 </input-label>
        </el-col>
        <el-col :span="6">
          <el-form-item prop="boundary.jr_site_parcel_number" class="jr_site_parcel_number" size="small">
            <jr-text v-model="form.boundary.jr_site_parcel_number" :isEdit="isEdit" size="small" />
          </el-form-item>
        </el-col>
      </el-row>
    </collapse-group>

    <collapse-group title="添付書類" class="my file-area" :isOpen="isEdit">
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24">
          ※添付書類は
          <a :href="sumpleSubmissionsUrl" class="sumple-submissions" target="_blank" rel="noopener noreferrer">
            記載例 </a
          >をご確認の上、作成をお願いいたします。
        </el-col>
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24"
          >※写真は、可能な限り線路と対象地が入るように、JR用地外から撮影したものを添付してください。
        </el-col>
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message font-sm" :span="24">※線路内には絶対に入らないでください。 </el-col>
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="explanation-message caution-message font-sm" :span="24"
          >※現地測量を行う際は、必ずJR用地外の安全な場所で実施して下さい。<br />
          <span class="pl-4">線路内への立入りや電気設備への接近は列車との接触や感電の危険性があり大変危険です。 </span
          ><br />
          <span class="pl-4">測量が困難な場合は概算距離（目測で可）を記載して下さい。</span>
        </el-col>
      </el-row>
      <el-row class="input-row" v-if="isEdit">
        <el-col class="bottom-explanation-message font-sm" :span="24"
          >※形式はPDF,JPG,PNG,DOCX,DOC,XLSX,XLSで、1ファイル10Mまでとなります。
        </el-col>
      </el-row>
      <!-- 境界 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 境界(確認・立会・明示)申請書 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item
            prop="boundary.boundary_application_form_file_selected"
            class="boundary_application_form_file"
            size="small"
          >
            <jr-file-input
              v-if="isEdit"
              ref="boundary_application_form_file_ref"
              v-model="form.boundary.boundary_application_form_file"
              :fileType="FileTypes.BOUNDARY_APPLICATION_FORM"
              :allowExts="allowExts"
              @update:selected="form.boundary.boundary_application_form_file_selected = $event"
              size="small"
            />
            <jr-file-view v-else :fileId="form.boundary.boundary_application_form_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 本人確認写(免許書等) -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small identification-file-label">
          <input-label :required="false"
            ><el-col> 本人確認写(免許書等)</el-col><el-col>(立会に来られる方)</el-col></input-label
          >
        </el-col>
        <el-col :span="16">
          <el-form-item prop="boundary.identification_file_selected" class="identification_file" size="small">
            <jr-file-input
              v-if="isEdit"
              ref="identification_file_ref"
              v-model="form.boundary.identification_file"
              :fileType="FileTypes.BOUNDARY_IDENTIFICATION"
              :allowExts="allowExts"
              @update:selected="form.boundary.identification_file_selected = $event"
              size="small"
              :nullable="true"
            />
            <jr-file-view v-else :fileId="form.boundary.identification_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 委任状 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 委任状 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="boundary.power_of_attorney_file_selected" class="power_of_attorney_file" size="small">
            <jr-file-input
              v-if="isEdit"
              ref="power_of_attorney_file_ref"
              v-model="form.boundary.power_of_attorney_file"
              :fileType="FileTypes.BOUNDARY_POWER_OF_ATTORNEY"
              :allowExts="allowExts"
              @update:selected="form.boundary.power_of_attorney_file_selected = $event"
              size="small"
              :nullable="true"
            />
            <jr-file-view v-else :fileId="form.boundary.power_of_attorney_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 位置図 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 位置図 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="boundary.location_map_file_selected" class="location_map_file" size="small">
            <jr-file-input
              v-if="isEdit"
              ref="location_map_file_ref"
              v-model="form.boundary.location_map_file"
              :fileType="FileTypes.BOUNDARY_LOCATION_MAP"
              :allowExts="allowExts"
              @update:selected="form.boundary.location_map_file_selected = $event"
              size="small"
            />
            <jr-file-view v-else :fileId="form.boundary.location_map_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 平面図 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 平面図 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="boundary.ground_plan_file_selected" class="ground_plan_file" size="small">
            <jr-file-input
              v-if="isEdit"
              ref="ground_plan_file_ref"
              v-model="form.boundary.ground_plan_file"
              :fileType="FileTypes.BOUNDARY_GROUND_PLAN"
              :allowExts="allowExts"
              @update:selected="form.boundary.ground_plan_file_selected = $event"
              size="small"
            />
            <jr-file-view v-else :fileId="form.boundary.ground_plan_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 地積測量図 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 地積測量図 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item
            prop="boundary.survey_drawing_of_acreage_file_selected"
            class="survey_drawing_of_acreage_file"
            size="small"
          >
            <jr-file-input
              v-if="isEdit"
              ref="survey_drawing_of_acreage_file_ref"
              v-model="form.boundary.survey_drawing_of_acreage_file"
              :fileType="FileTypes.BOUNDARY_SURVEY_DRAWING_OF_ACREAGE"
              :allowExts="allowExts"
              @update:selected="form.boundary.survey_drawing_of_acreage_file_selected = $event"
              size="small"
              :nullable="true"
            />
            <jr-file-view v-else :fileId="form.boundary.survey_drawing_of_acreage_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 公図 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 公図 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="boundary.cadastral_map_file_selected" class="cadastral_map_file" size="small">
            <jr-file-input
              v-if="isEdit"
              ref="cadastral_map_file_ref"
              v-model="form.boundary.cadastral_map_file"
              :fileType="FileTypes.BOUNDARY_CADASTRAL_MAP"
              :allowExts="allowExts"
              @update:selected="form.boundary.cadastral_map_file_selected = $event"
              size="small"
            />
            <jr-file-view v-else :fileId="form.boundary.cadastral_map_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 登記事項証明書 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="isEdit"> 登記事項証明書 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item
            prop="boundary.certificate_of_registered_matters_file_selected"
            class="certificate_of_registered_matters_file"
            size="small"
          >
            <jr-file-input
              v-if="isEdit"
              ref="certificate_of_registered_matters_file_ref"
              v-model="form.boundary.certificate_of_registered_matters_file"
              :fileType="FileTypes.BOUNDARY_CERTIFICATE_OF_REGISTERED_MATTERS"
              :allowExts="allowExts"
              @update:selected="form.boundary.certificate_of_registered_matters_file_selected = $event"
              size="small"
            />
            <jr-file-view v-else :fileId="form.boundary.certificate_of_registered_matters_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <!-- 現地写真 -->
      <el-row class="input-row row-height">
        <el-col :span="8" class="text-xs align-middle error-message-padding-small">
          <input-label :required="false"> 現地写真 </input-label>
        </el-col>
        <el-col :span="16">
          <el-form-item prop="boundary.actual_place_photo_file_selected" class="actual_place_photo_file" size="small">
            <jr-file-input
              v-if="isEdit"
              ref="actual_place_photo_file_ref"
              v-model="form.boundary.actual_place_photo_file"
              :fileType="FileTypes.BOUNDARY_ACTUAL_PLACE_PHOTO"
              :allowExts="allowExts"
              @update:selected="form.boundary.actual_place_photo_file_selected = $event"
              size="small"
              :nullable="true"
            />
            <jr-file-view v-else :fileId="form.boundary.actual_place_photo_file" :tagView="true" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row class="input-row">
        <el-col :span="8" class="text-xs other_files_padding">
          <input-label>その他</input-label>
        </el-col>
        <el-col :span="16" class="general_attached_file">
          <general-attached-files
            v-if="isEdit"
            v-model="form.general_attached_file"
            ref="generalAttachedFilesRef"
            :isEdit="true"
            size="small"
            @update:modelValue="form.general_attached_file = $event"
          />
          <general-attached-files-view v-else :fileList="form.general_attached_file" />
        </el-col>
      </el-row>
    </collapse-group>

    <Suspense>
      <message-history-to-message-type
        v-if="isMessageHistoryVisible"
        :requestHeaderId="requestHeaderId"
        :targetMessageTypes="HISTORY_MESSAGE_TYPES"
      />
    </Suspense>
  </el-form>
  <boundary-save-confirm-dialog
    v-if="isEdit"
    v-model="saveConfirmDialogVisible"
    :mode="mode"
    :requestHeader="form"
    :fileRefs="fileRefs"
    :generalAttachedFilesRef="generalAttachedFilesRef"
    @sent="saveSent"
  />
</template>

<script lang="ts">
import { defineComponent, reactive, ref, watch, computed, PropType } from 'vue'
import { ElForm } from 'element-plus'
import { useRouter } from 'vue-router'

import JrText from '@/components/jr-parts/JrText.vue'
import JrDateTimePicker from '@/components/jr-parts/JrDateTimePicker.vue'
import JrButton from '@/components/jr-parts/JrButton.vue'
import JrButtonForJr from '@/components/jr-parts/JrButtonForJr.vue'
import JrCheckbox from '@/components/jr-parts/JrCheckbox.vue'
import JrGeocoder from '@/components/jr-parts/JrGeocoder.vue'
import JrNumber from '@/components/jr-parts/JrNumber.vue'
import JrMap from '@/components/jr-parts/JrMap.vue'
import JrFileInput from '@/components/jr-parts/JrFileInput.vue'
import JrFileView from '@/components/jr-parts/JrFileView.vue'
import InputKilo from '@/components/inputs/InputKilo.vue'
import GeneralAttachedFiles from '@/components/inputs/GeneralAttachedFiles.vue'
import GeneralAttachedFilesView from '@/components/inputs/GeneralAttachedFilesView.vue'
import DepartmentSelect from '@/components/inputs/DepartmentSelect.vue'
import DirectionSelect from '@/components/inputs/DirectionSelect.vue'
import LineSelect from '@/components/inputs/LineSelect.vue'
import StationSelect from '@/components/inputs/StationSelect.vue'
import RequestReasonTypeSelect from '@/components/inputs/RequestReasonTypeSelect.vue'
import InputLabel from '@/components/inputs/InputLabel.vue'
import InputGroup from '@/components/layout/InputGroup.vue'
import FormItemDisabled from '@/components/layout/FormItemDisabled.vue'
import CollapseGroup from '@/components/layout/CollapseGroup.vue'
import MessageHistoryToMessageType from '@/components/others/MessageHistoryToMessageType.vue'
import BoundarySaveConfirmDialog from '@/components/dialogs/BoundarySaveConfirmDialog.vue'

import { RequestHeaderBoundaryDetailForm } from '@/types/forms'
import { FileTypes, RequestTypes, RequestReasonTypes, APPLICANT_UPLOAD_FILE_EXTS } from '@/constants/enums'
import { ReadRequest } from '@/requests/requestHeader'
import { DEFAULT_CENTER_LAT, DEFAULT_CENTER_LNG, DEFAULT_ZOOM, PIN_ZOOM } from '@/constants/map'
import Loggers from '@/services/logger'
import { boundaryEditRule } from '@/constants/rules'
import { MessageTypes } from '@/constants/messageTypes'
import MessageService from '@/services/message'
import { addMessageQueue, MESSAGE_TYPE_TOAST } from '@/plugins/messageQueue'

/**
 * 動作モード
 * view: 表示
 * edit: 編集
 * add: 新規追加
 * detail: 詳細
 */
type Mode = 'view' | 'edit' | 'add' | 'detail'

//履歴表示対象のメッセージ種別
const HISTORY_MESSAGE_TYPES = Object.freeze([
  MessageTypes.B_APPLICANT_CALL,
  MessageTypes.B_APPLICANT_CALL_RECV,
  MessageTypes.B_APPLICANT_CALL_SENDER_CALL,
  MessageTypes.APPLICANT_REGIST_BOUNDARY,
  MessageTypes.CHANGE_BOUNDARY_NOTICE,
  MessageTypes.PROXY_REGIST_BOUNDARY_NOTICE,
] as number[])

const blankRequestHeader: RequestHeaderBoundaryDetailForm = Object.freeze({
  boundary: Object.freeze({
    agent_address: '',
    agent_corporate_name: '',
    agent_name: '',
    contact_tel: '',
    request_reason_type: -1,
    request_reason_type_other: '',
    is_boundary_marker_confirm: false,
    is_boundary_marker_restore: false,
    is_boundary_fixed_surveying: false,
    location: '',
    parcel_number: '',
    land_category: '',
    parcel_area: '',
    line: null,
    line_name: '',
    start_station: null,
    end_station: null,
    start_station_name: '',
    end_station_name: '',
    latitude: '',
    longitude: '',
    jr_site_location: '',
    jr_site_parcel_number: '',
    request_header: 1,
    boundary_application_form_file: -1,
    // 本人確認写・委任状・地積測量図・現地写真はnull許可のため、nullで指定
    identification_file: null,
    power_of_attorney_file: null,
    location_map_file: -1,
    ground_plan_file: -1,
    survey_drawing_of_acreage_file: null,
    cadastral_map_file: -1,
    certificate_of_registered_matters_file: -1,
    actual_place_photo_file: null,
    work_content_count: 0,
    boundary_application_form_file_selected: false,
    identification_file_selected: false,
    power_of_attorney_file_selected: false,
    location_map_file_selected: false,
    ground_plan_file_selected: false,
    survey_drawing_of_acreage_file_selected: false,
    cadastral_map_file_selected: false,
    certificate_of_registered_matters_file_selected: false,
    actual_place_photo_file_selected: false,
  }),
  general_attached_file: [],
  request_type: RequestTypes.BOUNDARY,
  applicant_number: '',
  applicant_time: '',
  applicant_email: '',
  department_code: '',
  department_name: '',
  applicant_title: '',
  applicant_business_name: '',
  applicant_manager_name: '',
  applicant_address: '',
  applicant_tel: '',
  meter: undefined,
  direction: null,
  department: undefined,
  is_tanto_department_login_user: false,
})

/**
 * 境界立会情報
 * props.modeによりボタン等の表示切替を行う
 */
export default defineComponent({
  emits: ['update:form'],
  name: 'BoundaryInfo',
  components: {
    InputKilo,
    InputLabel,
    InputGroup,
    JrText,
    DepartmentSelect,
    JrDateTimePicker,
    JrButton,
    JrButtonForJr,
    DirectionSelect,
    JrNumber,
    LineSelect,
    StationSelect,
    RequestReasonTypeSelect,
    FormItemDisabled,
    JrCheckbox,
    JrGeocoder,
    JrMap,
    JrFileInput,
    JrFileView,
    GeneralAttachedFiles,
    GeneralAttachedFilesView,
    CollapseGroup,
    MessageHistoryToMessageType,
    BoundarySaveConfirmDialog,
  },
  props: {
    // 申請基本ID
    requestHeaderId: {
      type: Number,
      required: false,
      default: null,
    },
    // 動作モード
    mode: {
      type: String as PropType<Mode>,
      required: false,
      default: 'view',
    },
  },
  setup(props, context) {
    const router = useRouter()

    const formRef = ref<InstanceType<typeof ElForm>>()
    const generalAttachedFilesRef = ref<InstanceType<typeof GeneralAttachedFiles>>()
    const boundary_application_form_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const identification_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const power_of_attorney_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const location_map_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const ground_plan_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const survey_drawing_of_acreage_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const cadastral_map_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const certificate_of_registered_matters_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const actual_place_photo_file_ref = ref<InstanceType<typeof JrFileInput>>()
    const fileRefs = [
      boundary_application_form_file_ref,
      identification_file_ref,
      power_of_attorney_file_ref,
      location_map_file_ref,
      ground_plan_file_ref,
      survey_drawing_of_acreage_file_ref,
      cadastral_map_file_ref,
      certificate_of_registered_matters_file_ref,
      actual_place_photo_file_ref,
    ]
    const form = reactive<RequestHeaderBoundaryDetailForm>({
      ...blankRequestHeader,
      boundary: { ...blankRequestHeader.boundary },
    })
    const mapCenterLat = ref<string>(DEFAULT_CENTER_LAT)
    const mapCenterLng = ref<string>(DEFAULT_CENTER_LNG)
    const mapZoom = ref<number>(DEFAULT_ZOOM)
    // GoogleMapを読み込むかどうか
    const mapLoad = ref<boolean>(false)
    const changeMapCenter = () => {
      mapZoom.value = PIN_ZOOM
      // 変更時は座標をリセットする
      form.boundary.latitude = ''
      form.boundary.longitude = ''
    }

    const validationError = ref<{ start_station?: string; end_station?: string }>({})

    watch(
      () => props.requestHeaderId,
      async (id) => {
        if (props.mode === 'add') {
          // 新規登録時は取得しない
          return
        }
        const request = new ReadRequest(id)
        if (await request.exec()) {
          if (request.getRequestType() !== RequestTypes.BOUNDARY) {
            // 近接工事では無ければ404へ飛ばす
            Loggers.info('申請種別が異なります。')
            router.push({ name: 'NotFound' })
            return
          }
          const requestHeader = request.getBoundary()
          // 取得した情報をformに入れる
          Object.assign(form, requestHeader)
          mapZoom.value = PIN_ZOOM
          mapCenterLat.value = requestHeader.boundary.latitude
          mapCenterLng.value = requestHeader.boundary.longitude
        }
      },
      { immediate: true }
    )

    // form変更時はemitする
    watch(
      () => form,
      () => {
        context.emit('update:form', form)
      },
      { deep: true }
    )

    // 開始駅・終了駅の監視
    watch(
      () => [form.boundary.start_station, form.boundary.end_station],
      () => {
        if ((form.boundary.start_station == null) === (form.boundary.end_station == null)) {
          // どちらも入力されたか、どちらも入力されていない場合エラーをクリアする
          validationError.value = {}
        }
      },
      { deep: true }
    )

    // 作業内容選択数の監視
    watch(
      () => [
        form.boundary.is_boundary_marker_confirm,
        form.boundary.is_boundary_marker_restore,
        form.boundary.is_boundary_fixed_surveying,
      ],
      (workContents) => {
        // trueの合計を調べる
        form.boundary.work_content_count = workContents.filter((content) => content).length
      },
      { deep: true }
    )

    // モード別動作
    // 編集可否 新規・編集は編集モード
    const isEdit = computed(() => props.mode === 'add' || props.mode === 'edit')
    // 戻り先
    const returnTo = computed(() => {
      if (props.mode === 'view' || props.mode === 'edit') {
        // 表示モード・編集モードは詳細画面に戻る
        return {
          name: 'BoundaryDetail',
          params: {
            request_header_id: props.requestHeaderId,
          },
        }
      } else {
        // 新規・詳細モードは一覧に戻る
        return {
          name: 'BoundaryList',
          query: {
            screen: props.mode, // モードをクエリストリングに付与
          },
        }
      }
    })
    // 変更ボタン表示 詳細画面のみ表示
    const isEditBtnVisible = computed(() => props.mode === 'detail')
    // 協議先連絡ボタン  詳細画面のみ表示
    const isApplicantContactBtnVisible = computed(() => props.mode === 'detail')
    // メッセージ履歴表示 詳細画面のみ表示
    const isMessageHistoryVisible = computed(() => props.mode === 'detail')

    const saveConfirmDialogVisible = ref<boolean>(false)
    const save = () => {
      if (!formRef.value) {
        return
      }
      formRef.value.validate((valid) => {
        if ((form.boundary.start_station == null) !== (form.boundary.end_station == null)) {
          // 開始駅・終了駅のどちらかのみ入力されている場合エラー
          if (form.boundary.start_station == null) {
            validationError.value.start_station = MessageService.bind(MessageService.codes.V_REQUIRED_SELECT_IF, {
              target: '終了駅',
              attribute: '開始駅',
            })
          } else {
            validationError.value.end_station = MessageService.bind(MessageService.codes.V_REQUIRED_SELECT_IF, {
              target: '開始駅',
              attribute: '終了駅',
            })
          }
          return
        } else {
          validationError.value = {}
        }
        if (valid) {
          saveConfirmDialogVisible.value = true
        }
      })
    }

    /**
     * 保存後処理
     */
    const saveSent = () => {
      if (props.mode === 'edit') {
        // 編集時は詳細に戻る
        router.push({
          name: 'BoundaryDetail',
          params: {
            request_header_id: props.requestHeaderId,
          },
        })
      } else {
        // 新規登録時は一覧に戻る
        router.push({
          name: 'BoundaryList',
          query: {
            screen: props.mode, // モードをクエリストリングに付与
          },
        })
      }
      addMessageQueue(
        MESSAGE_TYPE_TOAST,
        MessageService.bind(MessageService.codes.SAVE_COMPLETE, { target: '境界立会申請' })
      )
    }

    return {
      form,
      formRef,
      mapCenterLat,
      mapCenterLng,
      mapZoom,
      mapLoad,
      mapCollapseChange: () => {
        // MapのCollapseが変化するとmap読み込みを有効化する
        mapLoad.value = true
      },
      changeMapCenter,
      fileRefs,
      generalAttachedFilesRef,
      boundary_application_form_file_ref,
      identification_file_ref,
      power_of_attorney_file_ref,
      location_map_file_ref,
      ground_plan_file_ref,
      survey_drawing_of_acreage_file_ref,
      cadastral_map_file_ref,
      certificate_of_registered_matters_file_ref,
      actual_place_photo_file_ref,
      validationError,
      isEdit,
      returnTo,
      isEditBtnVisible,
      isApplicantContactBtnVisible,
      isMessageHistoryVisible,
      rules: boundaryEditRule,
      save,
      saveSent,
      saveConfirmDialogVisible,
      MessageTypes,
      FileTypes,
      allowExts: APPLICANT_UPLOAD_FILE_EXTS,
      RequestReasonTypes,
      HISTORY_MESSAGE_TYPES,
      sumpleSubmissionsUrl: process.env.VUE_APP_BOUNDARY_SUMPLE_SUBMISSIONS_URL,
    }
  },
})
</script>

<style lang="scss" scoped>
.el-form {
  padding-bottom: 50px;
}

.file-area {
  ::v-deep(label) {
    max-width: 130px;
  }
  ::v-deep(.el-button) {
    margin-right: 10px;
    margin-bottom: 5px;
    max-width: 700px;
  }
  ::v-deep(.el-button + .el-button) {
    margin-left: 0;
  }
}

.identification-file-label {
  line-height: 20px;
  padding-left: 5px;
}
</style>
